import React from 'react';

import './industry-logos.scss';



const DecorIndustryLogos = () => {

    return (
        <>
            <div className='logos' id='indust-logos'>
                <a href='https://www.artlebedev.ru/fabrikant/logo/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/industry/industry_0.png"/>
                </a>
                <a href='https://www.artlebedev.ru/efko/logo/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/industry/industry_1.png"/>
                </a>
                <a href='https://www.artlebedev.ru/qazaqgaz/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/industry/industry_2.png"/>
                </a>
                <a href='https://www.artlebedev.ru/rb/identity/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/industry/industry_3.png"/>
                </a>
                <a href='https://www.artlebedev.ru/nord/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/industry/industry_4.png"/>
                </a>
                <a href='https://www.artlebedev.ru/atiss/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/industry/industry_5.png"/>
                </a>
                <a href='https://www.artlebedev.ru/saiver/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/industry/industry_6.png"/>
                </a>
                <a href='https://www.artlebedev.ru/l-pak/identity/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/industry/industry_7.png"/>
                </a>
                <a href='https://www.artlebedev.ru/iodico/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/industry/industry_8.png"/>
                </a>
            </div>
        </>
    );
}

export default DecorIndustryLogos;
